import { render, staticRenderFns } from "./ProductFormOptionItem.vue?vue&type=template&id=03b3f4b9"
import script from "./ProductFormOptionItem.vue?vue&type=script&lang=js"
export * from "./ProductFormOptionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports